/**
 * @class DrawerTrigger
 * @description Handles opening drawers based on data-open-drawer attribute
 * @extends HTMLElement
 */
class DrawerTrigger extends HTMLElement {

  connectedCallback() {
    this.abortController = new AbortController();
    this.addEventListener('click', (event) => this.handleClick(event), {
      signal: this.abortController.signal
    });
  }

  disconnectedCallback() {
    this.abortController?.abort();
  }

  handleClick(event) {
    event.preventDefault();
    const trigger = event.target.closest('[data-open-drawer]');
    if (!trigger) return;
    const drawerTarget = trigger.dataset?.openDrawer;
    document.querySelector(`custom-drawer[data-drawer-target="${drawerTarget}"]`)?.open();
  }
}

if (!customElements.get('drawer-trigger')) {
  customElements.define('drawer-trigger', DrawerTrigger);
}
